import styled from "styled-components";

export const TabsContainer = styled.div<{ contentwidth?: number }>`
  .ant-tabs-tab {
    color: var(--text-2, #a3aed0);
    font-family: DM Sans;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px; /* 160% */
    padding: unset;
  }
  .ant-tabs-nav::before {
    border-bottom: 1px solid var(--shadow, #dadeec);
    padding: 24px;
  }
  .ant-tabs-ink-bar {
    height: unset !important;
  }
  .ant-tabs-nav {
    padding-bottom: 24px;
    margin-bottom: 24px !important;
  }
  .boxHolder {
    display: flex;
    padding: 8px 12px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border-radius: 6px;
    border: 1px solid var(--sidebar-icon, #a3aed0);
    color: var(--text, #001377);
    text-align: center;
    font-family: DM Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.42px;
  }
  .titleHolder {
    color: var(--text-3, #5d6881);
    font-family: DM Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    white-space: nowrap;
  }
  .ant-tabs-tabpane-active {
    transition: all 0.5s;
    ${({ contentwidth }) => {
      if (contentwidth) {
        return `    width: ${contentwidth}px ;        `;
      } else return "";
    }}
  }
`;
